function closeSlideout() {
    $('.slideout-overlay, .slideout').removeClass('visible');
    $('body').removeClass('is-slideout');
}

function openSlideout(slideout, overlay = true) {
    // overlay = typeof overlay !== 'undefined' ? overlay : true; 

    $(slideout).addClass('visible');
    $('body').addClass('is-slideout');

    setTimeout(function () {
        $(slideout).find('.fields li input, .fields li textarea').each(function () {
            var $this = $(this);
            if ($this.val() !== '') {
                $this.parent('li').addClass('filled');
            } else {
                $this.parent('li').removeClass('filled');
            }
        });
    }, 100);

    if (overlay) {
        $('.slideout-overlay').addClass('visible');
    }

}

var slideoutDragging = false;

$('body').on('touchstart', function () {
    slideoutDragging = false;
});

$('body').on('touchmove', function () {
    slideoutDragging = true;
});

$('body').on('click touchend', function (e) {
    var className = $(e.target).attr('class');
    if (className === 'overlay visible' || className === 'slideout-overlay visible') {

        if (slideoutDragging) {
            return false;
        }

        e.stopPropagation();

        closeSlideout();
    }
});

$(document).keyup(function (e) {
    if (e.keyCode === 27) { // Esc
        closeSlideout();
    }
});

$('body').on('click', '.close-slideout', function () {
    closeSlideout();
    return false;
});